module.exports = {"id":"229906","name":"Leon Bailey","rating":"82","photo":"./data/images/photos/0/229906.png","club":{"name":"Bayer 04","logo":"./data/images/clubs/Bayer04.png"},"positions":["MG","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeonBailey0.json
// module id = 2480
// module chunks = 0